import { css } from '@linaria/core';
export const HasDisabledAnimations = {
    base: css `
		&& {
			transition-duration: 0ms !important;
			animation-duration: 0ms !important;
		}
	`,
};
